export default __webpack_public_path__ + "static/media/aliado-calzada-code.a4ec815f.png";